import React from "react";
import Slider from "react-slick";
import Card from "../cards/Cards";
import { CardProps } from "../cards/Cards";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slider.css";
import LeftArrow from "../../../assets/sliderArrows/LeftArrow";
import RightArrow from "../../../assets/sliderArrows/RightArrow";
import useScreenHook from "../../../utils/helperFunctions/useScreenHook";
import NoDataComponent from "../NoDataComponent";
interface SliderProps {
  cards: CardProps[];
  mediaType: string;
}

const SliderComponent: React.FC<SliderProps> = ({
  cards,
  mediaType = "digital",
}) => {
  const { deviceType = "desktop" } = useScreenHook();
  const settings = {
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: deviceType === "desktop" ? 5 : 2,
    slidesToScroll: 1,
    prevArrow: <LeftArrow />,
    nextArrow: <RightArrow />,
  };
  if (!cards || !cards.length) return <NoDataComponent />;

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {cards.map((card) => (
          <Card
            {...card}
            key={card.title}
            publisher={card?.sourceName}
            date={card?.pubDate}
            img={card.image_url}
            mediaType={mediaType}
            sourceIcon={card?.source_icon || ""}
          />
        ))}
      </Slider>
    </div>
  );
};

export default SliderComponent;
